<div class="dialog-overlay" (click)="onClose()">
  <div class="location-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2 class="dialog-title">Location Change</h2>
      <button class="close-button" (click)="onClose()">×</button>
    </div>
    
    <div class="location-container">
      <!-- Inpatient Locations -->
      <div class="location-column">
        <h3>Inpatient Locations</h3>
        <div class="location-options">
          <div *ngFor="let location of inpatientLocations" 
               class="location-option"
               [class.disabled]="isLocationDisabled(location.name)"
               [class.selected]="selectedNewLocation === location.name"
               (click)="selectLocation(location.name)">
            <img [src]="location.image" [alt]="location.name">
            <span>{{ location.name }}</span>
          </div>
        </div>
      </div>

      <!-- Outpatient Locations -->
      <div class="location-column">
        <h3>Outpatient Locations</h3>
        <div class="location-options">
          <div *ngFor="let location of outpatientLocations" 
               class="location-option"
               [class.disabled]="isLocationDisabled(location.name)"
               [class.selected]="selectedNewLocation === location.name"
               (click)="selectLocation(location.name)">
            <img [src]="location.image" [alt]="location.name">
            <span>{{ location.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-wrapper">
      <button 
        class="btn-primary" 
        [disabled]="!selectedNewLocation"
        (click)="onChangeLocation()">
        Change Location
      </button>
      <button class="btn-secondary" (click)="onClose()">Close</button>
    </div>
  </div>
</div> 